/**
 * Mimu — "Step 2" and "Step 3" markers inside the Appstle widget.
 *
 * Step 1 is pure CSS in snippets/mimu-tier-track.liquid, since it hangs off a
 * heading that file already owns. These two need JavaScript because they attach to
 * elements Appstle renders client-side.
 *
 * Anchoring, in order of confidence:
 * v2: both markers moved ABOVE what they label rather than below/inside it. Step 3
 * now precedes the add-to-cart button, and step 2 climbs out of the subscribe card
 * before inserting, so it sits above the card instead of inside its top edge.
 *
 *   Step 3 — inserted straight before '.ab-mix-and-match-add-to-cart-button'. That
 *            selector is proven: the sticky bar forwards taps to it and the
 *            empty-state styling already keys off it.
 *   Step 2 — has no known class. Located by finding the widget's subscribe option
 *            by its visible text and inserting above it. If no such text is found
 *            the marker simply never renders, rather than landing somewhere wrong.
 *
 * Everything is inserted as a SIBLING and marked, never woven into Appstle's own
 * nodes, because the widget rebuilds itself constantly and would discard anything
 * placed inside it.
 */
(function () {
  var ATC = '.ab-mix-and-match-add-to-cart-button';
  var SUBSCRIBE = /^\s*subscribe\b/i;
  var MAX_CLIMB = 5;

  var scheduled = false;

  function marker(step) {
    var el = document.createElement('p');
    el.className = 'mimu-step';
    el.setAttribute('data-mimu-step', step);
    el.textContent = 'Step ' + step;
    return el;
  }

  function widgetRoot(button) {
    var node = button;
    for (var i = 0; i < MAX_CLIMB && node.parentElement; i++) node = node.parentElement;
    return node;
  }

  /**
   * The whole subscribe card, not just the element holding its label.
   *
   * Climbs from the matched text to the OUTERMOST ancestor whose own text still
   * begins with "Subscribe" — that boundary is the card itself, because the moment
   * a parent also contains the one-time option its text no longer starts there.
   * A fixed climb of three levels was what previously left the marker inside the
   * card's top edge; this finds the real edge instead of counting.
   */
  function subscribeCard(root) {
    var all = root.querySelectorAll('*');

    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el.children.length) continue;
      if (!SUBSCRIBE.test(el.textContent || '')) continue;

      var node = el;
      for (var j = 0; j < 6; j++) {
        var parent = node.parentElement;
        if (!parent || parent === root) break;
        // Reached a container shared with the add-to-cart bar: gone too far.
        if (parent.querySelector(ATC)) break;
        // Parent holds more than this option, so the card edge was the last node.
        if (!SUBSCRIBE.test(parent.textContent || '')) break;
        node = parent;
      }
      return node;
    }
    return null;
  }

  function place() {
    var button = document.querySelector(ATC);
    if (!button) return;

    // Step 3 — directly above the add-to-cart bar.
    if (!document.querySelector('[data-mimu-step="3"]')) {
      button.insertAdjacentElement('beforebegin', marker(3));
    }

    // Step 2 — above the subscribe card, if it can be identified.
    if (!document.querySelector('[data-mimu-step="2"]')) {
      var card = subscribeCard(widgetRoot(button));
      if (card && card.parentElement) {
        card.parentElement.insertBefore(marker(2), card);
      }
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      place();
    });
  }

  window.mimuSteps = {
    place: place,
    found: function () {
      return {
        two: document.querySelectorAll('[data-mimu-step="2"]').length,
        three: document.querySelectorAll('[data-mimu-step="3"]').length
      };
    }
  };

  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  setInterval(schedule, 800);
  schedule();
})();
